// Spider override (MOB special). PURE (ENG-1).
//
// Melee behaviour plus wall-climbing: when its horizontal move is blocked by a
// solid wall ahead, the spider climbs it (upward velocity) instead of only
// jumping — letting it scale sheer faces the greedy steer can't.
import type { MobDef } from '../../registry/schemas';
import { halfOf, type Entity, type MobContext } from '../entity';
import { meleeAI } from '../archetypes/melee';

/** Upward speed while climbing a wall (blocks/tick). */
const CLIMB_SPEED = 0.2;

export function spider(e: Entity, def: MobDef, ctx: MobContext): void {
  meleeAI(e, def, ctx);
  if (e.wishX === 0 && e.wishZ === 0) return;

  // Wall ahead in the desired direction (both foot and head blocked) → climb.
  const half = halfOf(e, def);
  const dir = Math.hypot(e.wishX, e.wishZ);
  const ax = Math.floor(e.x + (e.wishX / dir) * (half + 0.1));
  const az = Math.floor(e.z + (e.wishZ / dir) * (half + 0.1));
  const footWall = ctx.world.isSolid(ax, Math.floor(e.y), az);
  const headWall = ctx.world.isSolid(ax, Math.floor(e.y + 1), az);
  if (footWall && headWall) {
    e.vy = CLIMB_SPEED;
    e.onGround = false;
  }
}
